import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useEffect, Children, useContext, cloneElement } from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import { isFunction } from '../../utils/assertions.es.js';
import { runIfFn } from '../../utils/functions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { Drawer } from '../Drawer/Drawer.es.js';
import { PopoverBase } from '../PopoverBase/PopoverBase.es.js';
import { usePopover } from '../PopoverBase/usePopover.es.js';
import { PopoverContext } from './PopoverContext.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Popover = function Popover(_a) {
  var _b = _a,
      children = _b.children,
      _b$triggerEvent = _b.triggerEvent,
      triggerEvent = _b$triggerEvent === void 0 ? "click" : _b$triggerEvent,
      hasArrow = _b.hasArrow,
      isOpenProp = _b.isOpen,
      onClose = _b.onClose,
      onOpen = _b.onOpen,
      triggerRef = _b.triggerRef,
      placement = _b.placement,
      _b$closeOnBlur = _b.closeOnBlur,
      closeOnBlur = _b$closeOnBlur === void 0 ? true : _b$closeOnBlur,
      _b$closeDelay = _b.closeDelay,
      closeDelay = _b$closeDelay === void 0 ? 200 : _b$closeDelay,
      props = __objRest(_b, ["children", "triggerEvent", "hasArrow", "isOpen", "onClose", "onOpen", "triggerRef", "placement", "closeOnBlur", "closeDelay"]);

  var _usePopover = usePopover({
    triggerEvent: triggerEvent,
    onOpen: onOpen,
    onClose: onClose,
    hasArrow: hasArrow,
    triggerRef: triggerRef,
    placement: placement,
    closeOnBlur: closeOnBlur,
    closeDelay: closeDelay
  }),
      isOpen = _usePopover.isOpen,
      open = _usePopover.open,
      close = _usePopover.close,
      getTriggerProps = _usePopover.getTriggerProps,
      getPopoverProps = _usePopover.getPopoverProps;

  useEffect(function () {
    if (typeof isOpenProp !== "boolean") {
      return;
    }

    if (isOpenProp) {
      open();
    }

    if (!isOpenProp) {
      close();
    }
  }, [close, isOpenProp, open]);
  return (
    /* @__PURE__ */
    React.createElement(PopoverContext.Provider, {
      value: {
        isOpen: isOpen,
        open: open,
        close: close,
        getTriggerProps: getTriggerProps,
        getPopoverProps: getPopoverProps,
        rest: props
      }
    }, isFunction(children) ? children({
      isOpen: isOpen,
      close: close
    }) : children)
  );
};

Popover.displayName = " Popover";

var Trigger = function Trigger(_ref) {
  var children = _ref.children;
  var child = Children.only(children);

  var _useContext = useContext(PopoverContext),
      getTriggerProps = _useContext.getTriggerProps;

  return (
    /*#__PURE__*/
    cloneElement(child, getTriggerProps(child.props, child.ref))
  );
};

Trigger.displayName = "Popover.Trigger";

var Content = function Content(_c) {
  var _d = _c,
      children = _d.children,
      _d$drawerBreakpoint = _d.drawerBreakpoint,
      drawerBreakpoint = _d$drawerBreakpoint === void 0 ? "md" : _d$drawerBreakpoint,
      props = __objRest(_d, ["children", "drawerBreakpoint"]);

  var isDrawer = useBreakpoint(drawerBreakpoint);

  var _useContext2 = useContext(PopoverContext),
      isOpen = _useContext2.isOpen,
      getPopoverProps = _useContext2.getPopoverProps,
      close = _useContext2.close,
      rest = _useContext2.rest;

  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, isDrawer ?
    /* @__PURE__ */
    React.createElement(Drawer, __spreadValues({
      isVisible: isOpen,
      onClose: close
    }, rest),
    /* @__PURE__ */
    React.createElement(Drawer.Content, __spreadProps(__spreadValues({}, props), {
      maxWidth: "100%"
    }), children)) :
    /* @__PURE__ */
    React.createElement(PopoverBase, __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, getPopoverProps()), {
      onOpen: getPopoverProps().open
    }), rest), props), runIfFn(children, {
      close: close
    })))
  );
};

Content.displayName = "Popover.Content";
var Popover$1 = Object.assign(Popover, {
  Trigger: Trigger,
  Content: Content
});
export { Popover$1 as default };